import script from "./schema.vue?vue&type=script&setup=true&lang=js"
export * from "./schema.vue?vue&type=script&setup=true&lang=js"

import "./schema.vue?vue&type=style&index=0&id=66a2136b&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a2136b"]])

export default __exports__